import {lengthP, distanceP, getLerpP, getLerp} from "./Utils"
import {clamp} from 'src/helpers/MathUtils'


let abs = Math.abs
let TAU = Math.PI *2

export const pointNames = [
  'cheekbone_left',
  'cheekbone_right',
  'chin_bottom',
  'chin_ear_left',
  'chin_ear_right',
  'chin_left_1',
  'chin_left_2',
  'chin_left_3',
  'chin_left_4',
  'chin_left_5',
  'chin_right_1',
  'chin_right_2',
  'chin_right_3',
  'chin_right_4',
  'chin_right_5',
  'eye_left_bottom',
  'eye_left_bottom_inner',
  'eye_left_bottom_outer',
  'eye_left_inner',
  'eye_left_iris',
  'eye_left_outer',
  'eye_left_top',
  'eye_left_top_inner',
  'eye_left_top_outer',
  'eye_right_bottom',
  'eye_right_bottom_inner',
  'eye_right_bottom_outer',
  'eye_right_inner',
  'eye_right_iris',
  'eye_right_outer',
  'eye_right_top',
  'eye_right_top_inner',
  'eye_right_top_outer',
  'eyebrow_left_bottom',
  'eyebrow_left_bottom_inner',
  'eyebrow_left_bottom_outer',
  'eyebrow_left_inner',
  'eyebrow_left_outer',
  'eyebrow_left_top',
  'eyebrow_left_top_inner',
  'eyebrow_left_top_outer',
  'eyebrow_right_botom',
  'eyebrow_right_bottom_outer',
  'eyebrow_right_inner',
  'eyebrow_right_outer',
  'eyebrow_right_top',
  'eyebrow_right_top_inner',
  'eyebrow_right_top_outer',
  'eyebrow_rigth_bottom_inner',
  'forehead_1',
  'forehead_2',
  'forehead_3',
  'forehead_4',
  'forehead_left',
  'forehead_middle',
  'forehead_right',
  'mouth_bottom',
  'mouth_inner_bottom',
  'mouth_inner_left',
  'mouth_inner_left_bottom',
  'mouth_inner_left_top',
  'mouth_inner_right',
  'mouth_inner_right_bottom',
  'mouth_inner_right_top',
  'mouth_inner_top',
  'mouth_left',
  'mouth_left_bottom',
  'mouth_left_bottom_point_1',
  'mouth_left_top',
  'mouth_left_top_point_1',
  'mouth_right',
  'mouth_right_bottom',
  'mouth_right_bottom_point_1',
  'mouth_right_top',
  'mouth_right_top_point_1',
  'mouth_top',
  'nose_bottom',
  'nose_bridge_bottom',
  'nose_bridge_middle',
  'nose_bridge_top',
  'nose_left_bottom_inner',
  'nose_left_bottom_outer',
  'nose_left_top',
  'nose_left_top_inner',
  'nose_left_top_outer',
  'nose_right_bottom_inner',
  'nose_right_bottom_outer',
  'nose_right_top',
  'nose_right_top_inner',
  'nose_right_top_outer',
  'nose_tip',
  'temple_left',
  'temple_left_1',
  'temple_left_2',
  'temple_left_3',
  'temple_left_4',
  'temple_right',
  'temple_right_1',
  'temple_right_2',
  'temple_right_3',
  'temple_right_4',
]


export const pointNames_browLeft = [
  'eyebrow_left_inner',
  'eyebrow_left_bottom_inner',
  'eyebrow_left_bottom',
  'eyebrow_left_bottom_outer',
  'eyebrow_left_outer',
  'eyebrow_left_top_outer',
  'eyebrow_left_top',
  'eyebrow_left_top_inner',
  ]

export const pointNames_browRight = [

  'eyebrow_right_inner',
  'eyebrow_right_top_inner',
  'eyebrow_right_top',
  'eyebrow_right_top_outer',
  'eyebrow_right_outer',
  'eyebrow_right_bottom_outer',
  'eyebrow_right_botom', //!!!! misspelt
  'eyebrow_rigth_bottom_inner', //!!!! misspelt

]

export const pointNames_eyeLeft = [
  'eye_left_top',
  'eye_left_top_inner',
  'eye_left_inner',
  'eye_left_bottom_inner',
  'eye_left_bottom',
  'eye_left_bottom_outer',
  'eye_left_outer',
  'eye_left_top_outer',

  //'eye_left_iris',
]


export const pointNames_eyeRight = [
  'eye_right_top',
  'eye_right_top_outer',
  'eye_right_outer',
  'eye_right_bottom_outer',
  'eye_right_bottom',
  'eye_right_bottom_inner',
  'eye_right_inner',
  'eye_right_top_inner',

  //'eye_right_iris',
]


export const pointNames_nose = [
  'nose_bridge_top',
  'nose_right_top',
  'nose_right_top_inner',
  'nose_right_top_outer',
  'nose_right_bottom_outer',
  'nose_right_bottom_inner',
  'nose_bottom',
  'nose_left_bottom_inner',
  'nose_left_bottom_outer',
  'nose_left_top_outer',
  'nose_left_top_inner',
  'nose_left_top',
]

export const pointNames_noseLeft = [
  'nose_bridge_top',
  'nose_bridge_middle',
  'nose_bridge_bottom',
  'nose_tip',
  'nose_bottom',
  'nose_left_bottom_inner',
  'nose_left_bottom_outer',
  'nose_left_top_outer',
  'nose_left_top_inner',
  'nose_left_top',
]

export const pointNames_noseRight = [
  'nose_bridge_top',
  'nose_right_top',
  'nose_right_top_inner',
  'nose_right_top_outer',
  'nose_right_bottom_outer',
  'nose_right_bottom_inner',
  'nose_bottom',
  'nose_tip',
  'nose_bridge_bottom',
  'nose_bridge_middle',
]


export const pointNames_lipBase = [
  'mouth_inner_bottom',
  'mouth_inner_right_bottom',
  'mouth_inner_right',
  'mouth_right',
  'mouth_right_bottom_point_1',
  'mouth_right_bottom',
  'mouth_bottom',
  'mouth_left_bottom',
  'mouth_left_bottom_point_1',
  'mouth_left',
  'mouth_inner_left',
  'mouth_inner_left_bottom'
]

export const pointNames_lipTop = [
  'mouth_top',
  'mouth_right_top',
  'mouth_right_top_point_1',
  'mouth_right',
  'mouth_inner_right',
  'mouth_inner_right_top',
  'mouth_inner_top',
  'mouth_inner_left_top',
  'mouth_inner_left',
  'mouth_left',
  'mouth_left_top_point_1',
  'mouth_left_top',
]



export const pointNames_faceShape = [
  'forehead_middle',
  'forehead_3',
  'forehead_4',
  'forehead_right',
  'temple_right',
  'temple_right_1',
  'temple_right_2',
  'temple_right_3',
  'temple_right_4',
  'chin_ear_right',
  'chin_right_1',
  'chin_right_2',
  'chin_right_3',
  'chin_right_4',
  'chin_right_5',
  'chin_bottom',
  'chin_left_5',
  'chin_left_4',
  'chin_left_3',
  'chin_left_2',
  'chin_left_1',
  'chin_ear_left',

  'temple_left_4',
  'temple_left_3',
  'temple_left_2',
  'temple_left_1',
  'temple_left',
  'forehead_left',
  'forehead_1',
  'forehead_2',
]


/*
step 1 normalise template, input distances

template(normalise to rect, origin eyes-center)
input(normalise by chin-eye distance, then (template-rect/ template-chin-eye))

origin = centerpoint between tear ducts

//important landmarks

POSITION_Y(origin distance2D or distanceY):

forehead_middle

y_eyes :: eye_left_inner <.> eye_right_inner

y_eyebrows : eyebrow_left_inner, eyebrow_right_inner

y_nose :: nose_bottom

y_mouth :: mouth_inner_bottom <.> mouth_inner_top

y_chin :: chin_bottom


POSITION_X(origin distance2D or distanceX):

x_eyebrow_left :: eyebrow_left_inner
x_eyebrow_right :: eyebrow_right_inner



WIDTHS(distance 2D or distanceX):

w_eyebrow_right :: eyebrow_right_inner <> eyebrow_right_outer
w_eyebrow_left :: eyebrow_left_inner <> eyebrow_left_outer

w_eye_left :: eye_left_inner <> eye_left_outer
w_eye_right :: eye_right_inner <> eye_right_outer

w_nose :: (nose_left_top_outer<.>nose_left_bottom_outer)<>(nose_right_top_outer<.>nose_right_bottom_outer)
w_mouth :: mouth_inner_left<>mouth_inner_right

w_faceshape :; max(template_left_4<>template_right_4, template_left_3<>template_right_3, template_left_2<>template_right_2)


HEIGHTS(distance 2D or distanceY):

h_eyebrow_right :: average( eyebrow_right_top <> eyebrow_right_bottom,
                            eyebrow_right_top_inner <>  eyebrow_right_bottom_inner
                            eyebrow_right_top_outer <>  eyebrow_right_bottom_outer
                            )

h_eyebrow_left :: average( eyebrow_left_top <> eyebrow_left_bottom,
                            eyebrow_left_top_inner <>  eyebrow_left_bottom_inner
                            eyebrow_left_top_outer <>  eyebrow_left_bottom_outer
                            )

h_eye_left :: eye_left_top <> eye_left_bottom

h_eye_right :: eye_right_top <> eye_right_bottom

h_nose :: average(nose_left_top_outer<>nose_left_bottom_outer),(nose_right_top_outer<>nose_right_bottom_outer)
h_mouth :: (mouth_top<>mouth_inner_top) + (mouth_bottom<>mouth_inner_bottom)

 */


var rect = {w:2480, h:3508};
var h2 = rect.h/2;
var w2 = rect.w/2;

const templatePointsPx_female = {

  mouth:{x:w2, y:2109},
  mouth_top:{x:w2, y:2040},
  mouth_base:{x:w2, y:2194},

  face_shape:{x:w2, y:511},

  bounds_rect:{x:0, y:0, w:2480, h:3508},
  face_rect:{x:w2, y:511, w: 1240, h: 1908},
  right_eye_rect:{x:1410, y:1452, w:241, h:103},
  right_eyebrow_rect:{x:1356, y:1332, w:319, h:64},
  nose_rect:{x:1083, y:1770, w:322, h:97},
  mouth_rect:{x:1035, y:2031, w:394, h:160},

  eye_center:{x:w2, y:1536},
  eyes:{x:1070, y:1536},
  eyes_right:{x:rect.w-1070, y:1540},

  eyes_left_outer:{x:837, y:1506},
  eyes_right_outer:{x:rect.w-837, y:1506},

  eyes_left_top:{x:957, y:1461},
  eyes_left_base:{x:957, y:1561},

  eye_brows:{x:1097, y:1404},
  eye_brows_right:{x:rect.w-1097, y:1404},
  eye_brows_top:{x:993, y:1339},
  eye_brows_base:{x:993, y:1389},

  nose:{x:w2, y:1926},
  nose_left:{x:1079, y:1819},
  nose_right:{x:rect.w-1079, y:1819},

  chin:{x:w2, y:2433}
};

const templatePointsPx_male = {

  mouth:{x:w2, y:2109},
  mouth_top:{x:w2, y:2040},
  mouth_base:{x:w2, y:2194},

  face_shape:{x:w2, y:511},

  bounds_rect:{x:0, y:0, w:2480, h:3508},
  face_rect:{x:w2, y:511, w: 1240, h: 1908},
  right_eye_rect:{x:1410, y:1452, w:241, h:103},
  right_eyebrow_rect:{x:1356, y:1332, w:319, h:64},
  nose_rect:{x:1083, y:1770, w:322, h:97},
  mouth_rect:{x:1035, y:2031, w:394, h:160},

  eye_center:{x:w2, y:1536},
  eyes:{x:1070, y:1536},
  eyes_right:{x:rect.w-1070, y:1536},

  eyes_left_outer:{x:837, y:1506},
  eyes_right_outer:{x:rect.w-837, y:1506},

  eyes_left_top:{x:957, y:1461},
  eyes_left_base:{x:957, y:1561},

  eye_brows:{x:1097, y:1404},
  eye_brows_right:{x:rect.w-1097, y:1404},
  eye_brows_top:{x:993, y:1339},
  eye_brows_base:{x:993, y:1389},

  nose:{x:w2, y:1926},
  nose_left:{x:1079, y:1819},
  nose_right:{x:rect.w-1079, y:1819},

  chin:{x:w2, y:2538}
};



const normalizeP = function(p){
  let o = templatePointsPx_female.eye_center;

  let unit = rect.h

  if (p.w){ //rect
    return{
      x: ( p.x - o.x )/unit,
      y: ( p.y - o.y )/unit,
      w: p.w /unit,
      h: p.h /unit
    }
  }

  return { //point
    x: (  p.x - o.x )/unit,
    y: ( p.y - o.y )/unit
  }
};


export const templatePointsRectUnit_female = {}
for (let k in templatePointsPx_female){templatePointsRectUnit_female[k] = normalizeP(templatePointsPx_female[k])}

export const templatePointsRectUnit_male = {}
for (let k in templatePointsPx_male){templatePointsRectUnit_male[k] = normalizeP(templatePointsPx_male[k])}


class FaceGeoModel {
  constructor(){
    this.female = true

    this._pxScaler = 1
    this._pointsUnit_f = templatePointsRectUnit_female
    this._pointsPx_f = templatePointsPx_female
    this._pointsUnit_m = templatePointsRectUnit_male
    this._pointsPx_m = templatePointsPx_male
  }

  get pointsUnit(){
    return (this.female)? this._pointsUnit_f : this._pointsUnit_m
  }

  get pointsPx(){
    return (this.female)? this._pointsPx_f : this._pointsPx_m
  }

  setGeo(geoStraight, geoBasicStraight, female){
    this.female = female

    this._pxScaler  = 1 /(this.unitScaler * lengthP(geoStraight.chin_bottom))
    //this._pxScaler = unit
    this.geoStraight = this.normaliseInput(geoStraight)
    this.geoBasicStraight = this.normaliseInput(geoBasicStraight)

    this.setPointGroups()

  }

  setPointGroups(){
    this.geoStraightArray =[]
    for (let k in this.geoStraight){
      let p = this.geoStraight[k]
      this.geoStraightArray.push(p)
    }

    this.faceShapePoints = this.makePolygonPoints(pointNames_faceShape)
    this.lipTopPoints = this.makePolygonPoints(pointNames_lipTop)
    this.lipBasePoints = this.makePolygonPoints(pointNames_lipBase)
    this.nosePoints = this.makePolygonPoints(pointNames_nose)
    this.eyeLeftPoints = this.makePolygonPoints(pointNames_eyeLeft)
    this.eyeRightPoints = this.makePolygonPoints(pointNames_eyeRight)
    this.eyeBrowLeftPoints = this.makePolygonPoints(pointNames_browLeft)
    this.eyeBrowRightPoints = this.makePolygonPoints(pointNames_browRight)
  }

  makePolygonPoints( namearr){
    let points = []
    for (let k of namearr){
      let p = this.geoStraight[k]
      points.push(p)
    }
    return points
  }




  normalize(p){
    p.x *= this.pixScaler
    p.y *= this.pixScaler

    return p
  }

  normaliseInput(geo){
    let o = {}
    //let midEyePoint
    for (let k in geo){
      let p = Object.assign({}, geo[k])
      o[k] = this.normalize(p)
    }
    return o
  }

  get draw_origin_unit(){
    return {x:0.5, y:(this.pointsPx.eye_center.y/this.pointsPx.bounds_rect.h)}
  }

  get origin(){return this.pointsUnit.eye_center}
  get eyesDistance(){return this.pointsUnit.eyes * 2}
  get chinDistance(){ return this.pointsUnit.chin}
  get faceWidth() { return  this.pointsUnit.face_rect.w }


  get unitScaler() {return this.pointsUnit.bounds_rect.h / this.pointsUnit.chin.y}
  get pixScaler(){ return this._pxScaler }


  get scaleX_eyebrow(){
    //let inputX = this.geoStraight.eye_brows_right
    //return /this.pointsUnit
    return 1
  }

  get scaleX_face(){
    let tw = this.faceWidth
    let g = this.geoStraight
    let iw1 = distanceP(g.temple_right_4, g.temple_left_4)
    let iw2 = distanceP(g.temple_right_2, g.temple_left_2)
    let iw3 = distanceP(g.temple_right_3, g.temple_left_3)

    let iw = this.maxA([iw1, iw2, iw3])

    return clamp(1.0+(iw-tw), 0.97, 1.06)
  }

  get y_mouth(){
    //y_mouth :: mouth_inner_bottom <.> mouth_inner_top
    let g = this.geoStraight
    let ip = getLerpP(g.mouth_inner_bottom, g.mouth_inner_top, 0.5)
    let iy = lengthP(ip)
    let ty = this.pointsUnit.mouth.y

    let oy = iy - ty

    return clamp(oy, -0.15, 0.15)
  }

  get y_nose(){
    //y_nose :: nose_bottom
    let g = this.geoStraight
    let iy = lengthP(g.nose_bottom)
    let ty = this.pointsUnit.nose.y

    let oy = iy - ty

    return clamp(oy, -0.05, 0.1)
  }

  get y_brow(){

    let g = this.geoStraight

    let iy1 = g.eyebrow_right_inner.y
    let iy2 = g.eyebrow_left_inner.y
    let iy = getLerp(iy1, iy2, 0.5)
    //let iy = -0.06100342075256556 //

    let ty = this.pointsUnit.eye_brows.y * (this.female ? 0.95 : 0.9)
    let oy = iy - ty

    //if(!this.female){ oy -= 0.01}
   // if(this.female && this.rot_brow>-0.02){ oy-=0.005}

    return clamp(oy, -0.1, 0.1)
  }

  get x_brow(){

    let g = this.geoStraight

    let iy1 = abs(g.eyebrow_right_inner.x)
    let iy2 = abs(g.eyebrow_left_inner.x)
    let iy = getLerp(iy1, iy2, 0.5)

    let ty = this.pointsUnit.eye_brows.x * 1.0

    let oy = iy - ty

    return clamp(oy, -0.02, 0.02)
  }

  get scaleX_brow(){
    return (this.female)? 0.9 : 0.85
  }

  get r_brow(){

    let g = this.geoStraight
    let iy = lengthP(g.nose_bottom)
    let ty = this.pointsUnit.nose.y

    let oy = iy - ty

    return clamp(oy, -0.35, 0.35)
  }

  get rot_brow(){
    let g = this.geoStraight

    //right brow
    let a1 = g.eyebrow_right_inner
    let a2 = g.eyebrow_right_bottom || g.eyebrow_right_botom

    let aRadians = Math.atan2(a2.y - a1.y, a2.x - a1.x);


    let b2 = g.eyebrow_left_inner
    let b1 = g.eyebrow_left_bottom

    let bRadians = Math.atan2(b2.y - b1.y, b2.x - b1.x);
    bRadians *= -1

    console.log('rot_brow', bRadians, aRadians )

    //return clamp( aRadians, -0.26, 0.26)

    return clamp(getLerp(bRadians, aRadians, 0.5), -0.2, 0.05)


  }

  get x_eye(){

    let g = this.geoStraight

    let iy1 = abs(g.eye_right_inner.x)
    let iy2 = abs(g.eye_left_inner.x)
    let iy = getLerp(iy1, iy2, 0.5)

    let ty = this.pointsUnit.eyes_right.x * 1.0

    let oy = iy - ty

    return clamp(oy, -0.01, 0.01)
  }

  get rot_eye(){
    let g = this.geoStraight

    //right brow
    let a1 = g.eye_right_inner
    let a2 = g.eye_right_outer

    let aRadians = Math.atan2(a2.y - a1.y, a2.x - a1.x);

    let b2 = g.eye_left_inner
    let b1 = g.eye_left_outer

    let bRadians = Math.atan2(b2.y - b1.y, b2.x - b1.x);
    bRadians *= -1

    //return getLerp(bRadians, aRadians, 0.5)
    return clamp(getLerp(bRadians, aRadians, 0.5), -0.2, 0.2)

  }


  //UTILS

  maxA(arr){
    let max = -100000000
    for (let o of arr){
      max = Math.max(o, max)
    }
    return max
  }




  //ref-art rect units
  //get noseOffsetY(){return this.artGeo.nose.y - this.origin.y}
  //get mouthOffsetY(){return this.artGeo.mouth.y - this.origin.y}

}

let m = new FaceGeoModel()
export default m





